import React from 'react'
import { Link } from 'react-router-dom'

import Script from 'dangerous-html/react'

import './footer.css'

const Footer = (props) => {
  return (
    <div className="footer-container1">
      <footer className="footer">
        <div className="footer-container">
          <div className="footer-top">
            <div className="footer-brand">
              <Link to="/">
                <div className="footer-thq-footer-logo-elm footer-logo">
                  <span className="footer-logo-text">ClearPath Digital</span>
                </div>
              </Link>
              <p className="footer-description section-content">
                {' '}
                High-performance, conversion-focused websites for businesses
                that mean business. We turn visitors into clients.
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </p>
            </div>
            <div className="footer-nav-grid">
              <div className="footer-column">
                <h3 className="section-subtitle footer-heading">Solutions</h3>
                <ul className="footer-list">
                  <li className="footer-item">
                    <Link to="/website-creation-main-service">
                      <div className="footer-thq-footer-link-elm1 footer-link">
                        <span>Website Creation</span>
                      </div>
                    </Link>
                  </li>
                  <li className="footer-item">
                    <Link to="/process-page">
                      <div className="footer-thq-footer-link-elm2 footer-link">
                        <span>Our Process</span>
                      </div>
                    </Link>
                  </li>
                  <li className="footer-item">
                    <Link to="/pricing">
                      <div className="footer-thq-footer-link-elm3 footer-link">
                        <span>Pricing Plans</span>
                      </div>
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="footer-column">
                <h3 className="section-subtitle footer-heading">Company</h3>
                <ul className="footer-list">
                  <Link to="/about">
                    <li className="footer-thq-footer-item-elm4 footer-item">
                      <div className="footer-link">
                        <span>About Us</span>
                      </div>
                    </li>
                  </Link>
                  <Link to="/contact-book-a-call">
                    <li className="footer-thq-footer-item-elm5 footer-item">
                      <div className="footer-link">
                        <span>Book a Call</span>
                      </div>
                    </li>
                  </Link>
                  <Link to="/gdpr-legal">
                    <li className="footer-thq-footer-item-elm6 footer-item">
                      <div className="footer-link">
                        <span>Privacy Policy</span>
                      </div>
                    </li>
                  </Link>
                  <li className="footer-item">
                    <Link to="/gdpr-legal">
                      <div className="footer-thq-footer-link-elm7 footer-link">
                        <span>Cookie Policy</span>
                      </div>
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="footer-column">
                <h3 className="section-subtitle footer-heading">Newsletter</h3>
                <p className="section-content footer-text">
                  Get conversion tips and agency updates.
                </p>
                <form
                  action="/subscribe"
                  method="POST"
                  data-form-id="281821c0-76d4-4cb3-b10c-8ac4c01a3c96"
                  className="footer-newsletter"
                >
                  <div className="footer-input-group">
                    <input
                      type="email"
                      id="thq_email_0bf8"
                      name="email"
                      required="true"
                      aria-label="Email address"
                      placeholder="Enter your email"
                      data-form-field-id="thq_email_0bf8"
                      className="footer-input"
                    />
                    <button
                      id="thq_button_jGnQ"
                      name="button"
                      type="submit"
                      aria-label="Subscribe"
                      data-form-field-id="thq_button_jGnQ"
                      className="footer-submit-btn"
                    >
                      <svg
                        fill="none"
                        width="24"
                        xmlns="http://www.w3.org/2000/svg"
                        height="24"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M5 12h14m-7-7l7 7l-7 7"></path>
                      </svg>
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div className="footer-bottom">
            <div className="footer-bottom-content">
              <p className="footer-copyright section-content">
                © 2025 ClearPath Digital. All rights reserved. Built for
                conversion.
              </p>
              <div className="footer-bottom-meta">
                <span className="footer-tag">EU / GDPR Compliant</span>
                <span className="footer-tag">
                  Service in France &amp; Luxembourg
                </span>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <div className="footer-container2">
        <div className="footer-container3">
          <Script
            html={`<script defer data-name="footer-newsletter">
(function(){
  const newsletterForm = document.querySelector('.footer-newsletter');
  
  if (newsletterForm) {
    newsletterForm.addEventListener('submit', (e) => {
      const emailInput = newsletterForm.querySelector('.footer-input');
      
      if (emailInput.checkValidity()) {
        const originalContent = newsletterForm.innerHTML;
        
        newsletterForm.innerHTML = \`
          <div style="color: #2ecc71; display: flex; align-items: center; gap: 8px; font-weight: 500;">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>
            Successfully subscribed!
          </div>
        \`;
        
        setTimeout(() => {
          newsletterForm.innerHTML = originalContent;
        }, 5000);
      }
    });
  }
})()
</script>`}
          ></Script>
        </div>
      </div>
    </div>
  )
}

export default Footer
